export default class LoginViewModel {
    public email: string;
    public password: string;
    public rememberMe: boolean;
}
